import $ from 'jquery';
import 'slick-carousel';


export default () => {
  $(".pdp_slidshow-wrapper").each(function() {
    let $wrapper = $(this);
    if ($wrapper.data('slideshow-inited')) {
      return;
    }
    $wrapper.slick({
      dots: true,
      swipeToSlide: true
    });
    $wrapper.data('slideshow-inited', true);
  });

  $('.tab-js').each(function(){
    let $tabContainer = $(this);
    if ($tabContainer.data('slideshow-inited')) {
      return;
    }

    let $tabSlider = $tabContainer.find(".tab-bar_slider");
    let $tabitems  = $tabContainer.find(".tab-bar_primary-navigation-item");
    let $tabDots   = $tabContainer.find(".tab-bar_secondary-navigation");
    let $panelBtn  = $tabContainer.find(".panel-js");
    let $panel     = $tabContainer.find(".tab-bar_side-panel-container");
    let $closeBtn  = $tabContainer.find(".panel-close-js");

    $tabSlider.slick({
      infinite: true,
      slidesToShow: 1,
      fade: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            appendDots: $tabDots,
            dots: true,
            fade: false
          }
        },
      ]
    });

    $panelBtn.on('click', function(){
      $panel.addClass('open');
    });

    $closeBtn.on('click', function() {
      $panel.removeClass('open');
    });

    $tabitems.on('click', function() {
      $tabSlider.slick('slickGoTo', this.dataset.index);
    });

    $tabSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $tabitems.removeClass('active');
      $($tabitems[nextSlide]).addClass('active');
    });

    $tabContainer.data('slideshow-inited', true);
  })

  // product grids
  $(window).on('load resize orientationchange', function() {
    $('.grid_js').each(function(){
      let $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 1024) {
        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }
      }
      else{
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            swipeToSlide: true,
            arrows: false,
            dots: true,
            infinite: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1
                }
              },
            ]
          });
        }
      }
    });
  });
}
